// TODO: this should be in it's own package (Copied from RosterFrontEndStaticWebsiteReact)
import { Dispatch, MiddlewareAPI } from "redux";
import { createAction } from "redux-starter-kit";
import { History } from "history";

export const redirectAction = createAction("reduxRouterRedirectAction");

type RedirectMiddleware = (
  _store: MiddlewareAPI
) => (next: Dispatch) => (action: any) => any;

const reduxRouterRedirectMiddleware = (
  routerHistory: History<any>
): RedirectMiddleware => {
  return (_store: MiddlewareAPI) => (next: Dispatch) => (action: any) => {
    if (redirectAction.toString() === action.type) {
      routerHistory.push(action.payload);
    }
    return next(action);
  };
};

export default reduxRouterRedirectMiddleware;
